import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { dateTime } from '@/lib/format';
import { useCanEdit } from '@/lib/queries';
import { ErrorNote, Spinner } from '@/components/Layout';

interface Row { id: string; title: string; type: string; starts_at: string; published: boolean; capacity: number | null; registrations: { status: string }[] }

export function AdminEvents() {
  const canEdit = useCanEdit();
  const events = useQuery({
    queryKey: ['admin-events'],
    queryFn: async () => {
      const { data, error } = await supabase.from('event').select('id,title,type,starts_at,published,capacity,registrations:event_registration(status)').order('starts_at', { ascending: false });
      if (error) throw error;
      return data as unknown as Row[];
    },
  });
  if (events.isLoading) return <Spinner />;
  if (events.error) return <ErrorNote>Could not load events.</ErrorNote>;
  const now = new Date().toISOString();
  return (
    <div className="space-y-4">
      {canEdit && <div className="flex justify-end"><Link to="/admin/events/new" className="btn-primary"><Plus size={16} /> New event</Link></div>}
      {!events.data?.length && <p className="card text-sm text-ink-500">No events yet. Create the first one.</p>}
      <ul className="card divide-y divide-stone-100 p-0">
        {events.data?.map(e => {
          const booked = e.registrations.filter(r => r.status === 'confirmed').length;
          const pending = e.registrations.filter(r => r.status === 'pending').length;
          return (
            <li key={e.id}>
              <Link to={`/admin/events/${e.id}`} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 hover:bg-stone-50">
                <span>
                  <span className="block font-medium">{e.title}</span>
                  <span className="block text-sm capitalize text-ink-500">{e.type} · {dateTime(e.starts_at)}{e.starts_at < now && ' · past'}</span>
                </span>
                <span className="flex items-center gap-2 text-sm">
                  <span>{booked}{e.capacity ? ` / ${e.capacity}` : ''} booked{pending ? `, ${pending} paying` : ''}</span>
                  <span className={`pill ${e.published ? 'bg-emerald-100 text-emerald-800' : 'bg-stone-100 text-ink-700'}`}>{e.published ? 'Published' : 'Draft'}</span>
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
